import { cva } from "class-variance-authority";

export const avatarVariants = cva(
  // Basic layout
  ["inline-grid align-middle *:col-start-1 *:row-start-1 text-white"],
  {
    defaultVariants: {
      color: "brand",
    },
    variants: {
      color: {
        transparent: "",
        brand: "bg-brand-700 text-brand-100",
        zinc: "bg-avatar-zinc",
        red: "bg-avatar-red",
        orange: "bg-avatar-orange",
        amber: "bg-avatar-amber",
        yellow: "bg-avatar-yellow",
        lime: "bg-avatar-lime",
        green: "bg-avatar-green",
        emerald: "bg-avatar-emerald",
        teal: "bg-avatar-teal",
        cyan: "bg-avatar-cyan",
        sky: "bg-avatar-sky",
        blue: "bg-avatar-blue",
        indigo: "bg-avatar-indigo",
        violet: "bg-avatar-violet",
        purple: "bg-avatar-purple",
        fuchsia: "bg-avatar-fuchsia",
        pink: "bg-avatar-pink",
        rose: "bg-avatar-rose",
      },
      shape: {
        square: "rounded *:rounded",
        circle: "rounded-full *:rounded-full",
        brand: "[clip-path:polygon(var(--winamp-polygon))]",
      },
    },
  },
);
